export default that => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    type: 'checkbox',
    fixed: 'left',
    visible: !that.disabled,
  },
  {
    title: that.$l('INDEX.table_label_packingOrder_retailerPo') || '零售商PO',
    field: 'retailerPo',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_packingOrder_custOrderNo') || '客户订单编号',
    field: 'custOrderNo',
    minWidth: 180,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_packingOrder_orderDepName') || '订单对应部门名称',
    field: 'orderDepName',
    minWidth: 180,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_packingOrder_customsNo') || '关单号',
    field: 'customsNo',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_packingOrder_showBookContractNo') || '外运合同号合集',
    field: 'showBookContractNo',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_packingOrder_customsBillNo') || '海关编号',
    field: 'customsBillNo',
    width: 180,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    editRender: {
      name: 'ElInput',
      props: {
        placeholder: that.$l('INDEX.tips_input_placeholder') || '请输入...',
        'controls-position': 'right',
        size: 'mini'
      },
    }
  },
  {
    title: that.$l('INDEX.table_label_packingOrder_totalCtnQty') || '总箱数',
    field: 'totalCtnQty',
    width: 120,
    align: 'center',
    isTotalColumn: true,
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ cellValue }) => cellValue.toLocaleString()
  },
  {
    title: that.$l('INDEX.table_label_packingOrder_totalGoodsQty') || '总产品数量',
    field: 'totalGoodsQty',
    width: 120,
    align: 'center',
    isTotalColumn: true,
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ cellValue }) => cellValue.toLocaleString()
  },
  {
    title: that.$l('INDEX.table_label_packingOrder_subPriceAmount') || '工厂金额',
    field: 'totalPriceAmount',
    isTotalColumn: true,
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ row }) => {
      const { v_totalPriceAmount: value, v_currencyUnit: unit } = row
      return value
        ? [value, unit].filter(Boolean).join(' ')
        : ''
    }
  },
  {
    title: that.$l('INDEX.table_label_packingOrder_subSalePriceAmount') || '客户金额',
    field: 'totalSalePriceAmount',
    isTotalColumn: true,
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ row }) => {
      const { v_totalSalePriceAmount: value, v_salesCurrencyUnit: unit } = row
      return value
        ? [value, unit].filter(Boolean).join(' ')
        : ''
    }
  },
  {
    title: that.$l('INDEX.table_label_packingOrder_subDeclarationAmount') || '报关金额',
    field: 'totalDeclarationAmount',
    isTotalColumn: true,
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ row }) => {
      const { v_totalDeclarationAmount: value, v_salesCurrencyUnit: unit } = row
      return value
        ? [value, unit].filter(Boolean).join(' ')
        : ''
    }
  }
]
